import React from "react";
import { ShieldCheck } from "lucide-react";
import { useLang } from "@/lib/lang";

/**
 * White-label ribbon shown at the very top of the landing when arriving via
 * ?partner=hotel-slug or a partner subdomain (e.g. hotel-tivoli.ditours.pt).
 */
export default function PartnerRibbon({ partnerCtx }) {
  const { t } = useLang();
  if (!partnerCtx) return null;
  return (
    <div className="dt-partner-ribbon" data-testid="partner-ribbon">
      <ShieldCheck size={14} /> {t("landing_partner_ribbon_prefix")}{" "}
      <strong>{partnerCtx.company_name}</strong> · {t("landing_partner_ribbon_suffix")}
    </div>
  );
}
